export default __webpack_public_path__ + "static/media/blog-installing-pavers-002.84fd5b9b.jpg";